import { Button, TYPE } from 'components/Button'
import Heading from 'components/Heading'
import Icon from 'components/Icon'
import { Modal } from 'components/Modal'
import { LOGO } from 'Icon/logo'
import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { getCdnUrl } from '../data/api/cdn'
import Content from './shared/content'
import Page from './shared/page_wrapper'

const Reload: React.FC<{}> = () => {
  const match = { isExact: true, path: '/', url: '/', params: {} }
  const reload = () => {
    window.location.reload()
  }

  return (
    <Page page="reload" match={match} navFooter>
      <Modal
        animationType={'1'}
        color={false}
        sticky={true}
        size="l"
        onDismiss={reload}
        headerlessModal={true}
        backgroundImage={getCdnUrl('pattern-random-green.jpg')}
      >
        <div className="content">
          <Icon icon={LOGO.symbol} viewBox="0 0 512 512" />
          <Heading>
            <Content contentKey="reload-heading">Website is updated</Content>
          </Heading>
          <p>
            <Content contentKey="reload-p">
              We watered it, shaved it and gave it a new haircut. Well, actually
              our site has just been updated. Click the button the refresh this
              page.
            </Content>
          </p>
          <Button cutOff={'left'} onClick={reload}>
            <DisplayContent edit={true} contentKey="open-website">
              Open website
            </DisplayContent>
          </Button>
        </div>
      </Modal>
    </Page>
  )
}

export default Reload
